/**
 * FormInput Component
 * Reusable form input with floating label
 */

import React, { forwardRef } from 'react';

import './form-input.scss';

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    error?: boolean;
    errorMessage?: string;
}

export const FormInput = React.memo(
    forwardRef<HTMLInputElement, FormInputProps>(
        ({ label, error, errorMessage, id, className = '', ...props }, ref) => {
            const wrapperClasses = ['form-input', error && 'form-input--error', className].filter(Boolean).join(' ');

            return (
                <div className={wrapperClasses}>
                    <input
                        ref={ref}
                        id={id}
                        className="form-input__input"
                        placeholder={props.placeholder || label}
                        {...props}
                    />
                    <label htmlFor={id} className="form-input__label">
                        {label}
                    </label>
                    {error && errorMessage && <span className="form-input__error">{errorMessage}</span>}
                </div>
            );
        },
    ),
);

FormInput.displayName = 'FormInput';

export default FormInput;
